export enum StockCostingType {
    LAST_COST,
    CURRENT_COST,
    AVERAGE_COST,
    CUSTOM_COST
}
